<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import AUApi from "@/api";
import { getKennungValueDisplay, getKennungTitle } from "@/DataHelper";
import { mountedBase, onSave, BaseSetup, onDelete } from "@/DataLoaderStatic";
const emit = defineEmits(["back", "save"]);
const props = defineProps<{
  zeitbereich: APIZeitbereich;
  aic: number;
}>();
let showInfo = ref<boolean>(false);

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_Reise_Status_Anzeige",
  emitBack: () => emit("back"),
};

const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));

onMounted(async () => {
  pageParams.aic = props.aic;
  pageParams.queryAIC = props.aic;
  pageParams.zeitbereich = props.zeitbereich;

  await mountedBase(uiData, pageParams);
  uiData.showLoading = false;
  uiData.initialized = true;
});
</script>
<template>
  <v-card :loading="uiData.showLoading" v-if="uiData.initialized">
    <v-card-text>
      <v-row>
        <v-col class="dvhCol">
          <span style="white-space: nowrap"
            >{{ getKennungTitle("RK_KATEGORIE", uiData.columns) }}:
          </span>
        </v-col>

        <v-col class="dvhCol">
          <span style="white-space: nowrap">{{
            getKennungValueDisplay(uiData.data[0], "RK_KATEGORIE", uiData.columns)
          }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="dvhCol">
          <span style="white-space: nowrap"
            >{{ getKennungTitle("RK_STATUSREISE", uiData.columns) }}:
          </span>
        </v-col>

        <v-col class="dvhCol">
          <span style="white-space: nowrap">{{
            getKennungValueDisplay(
              uiData.data[0],
              "RK_STATUSREISE",
              uiData.columns
            )
          }}</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="dvhCol">
          <span style="white-space: nowrap"
            >{{ getKennungTitle("RK_VORGAENGER_STATUS", uiData.columns) }}:
          </span>
        </v-col>

        <v-col class="dvhCol">
          <span style="white-space: nowrap">{{
            getKennungValueDisplay(
              uiData.data[0],
              "RK_VORGAENGER_STATUS",
              uiData.columns
            )
          }}</span>
        </v-col>
      </v-row>
      <v-row v-if="showInfo">
        <v-col class="dvhCol">
          <span style="white-space: nowrap"
            >{{ getKennungTitle("HINWEIS", uiData.columns) }}:
          </span>
        </v-col>
      </v-row>

      <div v-if="showInfo" style="white-space: pre-wrap">
        {{ getKennungValueDisplay(uiData.data[0], "HINWEIS", uiData.columns) }}
      </div>

      <v-row v-if="showInfo">
        <v-col class="dvhCol">
          <span style="white-space: nowrap"
            >{{ getKennungTitle("BESCHREIBUNG", uiData.columns) }}:
          </span>
        </v-col>
      </v-row>

      <div v-if="showInfo" style="white-space: pre-wrap">
        {{
          getKennungValueDisplay(uiData.data[0], "BESCHREIBUNG", uiData.columns)
        }}
      </div>
    </v-card-text>
  </v-card>
</template>
<style scoped>
.row {
  padding: 0px;
}
.dvhCol {
  padding-right: 0px;
  padding-left: 0px;
  padding-top: 0px;
  padding-bottom: 5px;
  align-items: left;
  text-align: left;
}
</style>
